import { Modal, Stack, SxProps, Theme } from "@mui/material";
import React, { useState } from "react";
import TextField from "./TextField";
import AIButton from "./AIButton";
import TextPromptModal from "./Modals/TextPromptModal";
import { TextGenType } from "../api/AICompletions";
import {
    hideLanguageSwitcher,
    showLanguageSwitcher,
} from "../utils/languageUtils";

interface Props {
    placeholder?: string;
    value?: string;
    width?: number | string;
    setText?: (val: string) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    error?: boolean;
    sx?: SxProps<Theme>;
    contextType: TextGenType;
    uuid: string;
    brandKey: string;
    serviceId?: string;
}

export interface DisplayMessage {
    role: "user" | "assistant";
    content: string;
}

const AIDescriptionField = (props: Props) => {
    const {
        placeholder,
        value,
        width,
        setText,
        onFocus,
        onBlur,
        error,
        sx,
        contextType,
        uuid,
        brandKey,
        serviceId,
    } = props;

    const [showModal, setShowModal] = useState(false);
    const [displayHistory, setDisplayHistory] = useState<DisplayMessage[]>([]);

    const showAI = () => {
        hideLanguageSwitcher();
        setShowModal(true);
    };

    const onCancel = () => {
        showLanguageSwitcher();
        setShowModal(false);
    };

    const onSave = (val?: string) => {
        if (val) setText?.(val);
        onCancel();
    };

    return (
        <>
            <Stack
                width={width}
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
            >
                <TextField
                    multiline
                    fullWidth
                    variant="outlined"
                    width={width}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => setText?.(e.currentTarget.value)}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    error={error}
                    height="auto"
                    padding={2}
                    sx={sx}
                />
                <AIButton
                    aiButtonId="ai-description-create-text"
                    variant="medium"
                    onClick={showAI}
                >
                    Create Text
                </AIButton>
            </Stack>
            <Modal open={showModal} onClose={() => {}}>
                <TextPromptModal
                    open={showModal}
                    value={value}
                    onCancel={onCancel}
                    onSave={onSave}
                    displayHistory={displayHistory}
                    setDisplayHistory={setDisplayHistory}
                    contextType={contextType}
                    uuid={uuid}
                    brandKey={brandKey}
                    serviceId={serviceId}
                />
            </Modal>
        </>
    );
};

export default AIDescriptionField;
